import ProjectsHero from './ProjectsHero';

export default ProjectsHero;
